/* eslint-disable react/prop-types */
import { FC, useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { Button } from "src/components/ui/button";
import MentionHashtagInput from "../MentionHashtagInput/MentionHashtagInput";

interface CommentInputProps {
	parentCommentId?: number | null;
	replyingTo?: string | null;
	onCancelReply?: () => void;
	onSubmit: (body: string, parentCommentId?: number | null) => void;
	isSubmitting?: boolean;
}

const CommentInput: FC<CommentInputProps> = ({
	parentCommentId = null,
	replyingTo = null,
	onCancelReply,
	onSubmit,
	isSubmitting = false
}) => {
	const [text, setText] = useState("");

	const handleSubmit = () => {
		if (!text.trim()) return;
		onSubmit(text.trim(), parentCommentId);
		setText("");
	};

	return (
		<div className="px-4 py-3 border-t border-border">
			{replyingTo && (
				<div className="flex items-center gap-2 mb-2 text-xs text-muted-foreground">
					<span>Replying to {replyingTo}</span>
					<button
						type="button"
						className="text-primary text-xs hover:underline"
						onClick={onCancelReply}
					>
						Cancel
					</button>
				</div>
			)}
			<div className="flex items-center gap-2">
				<MentionHashtagInput
					value={text}
					onChange={setText}
					placeholder={replyingTo ? "Write a reply..." : "Write a comment..."}
					className="flex-1 rounded-full border border-input bg-subtle px-4 py-2 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring resize-none overflow-hidden"
					minHeight="40px"
					onKeyDown={(e) => {
						if (e.key === "Enter" && !e.shiftKey) {
							e.preventDefault();
							handleSubmit();
						}
					}}
					disabled={isSubmitting}
				/>
				<Button
					type="button"
					size="icon"
					variant="ghost"
					className="h-9 w-9 rounded-full"
					disabled={!text.trim() || isSubmitting}
					onClick={handleSubmit}
					aria-label="Send comment"
				>
					{isSubmitting ? (
						<div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
					) : (
						<PaperPlaneTilt
							size={16}
							weight="duotone"
							className="text-primary"
						/>
					)}
				</Button>
			</div>
		</div>
	);
};

export default CommentInput;
